export enum UserStateEnum {
  GuestUser = 'GUEST_USER',
  UserIsLogged = 'USER_IS_LOGGED',
  UserIsLoggedOut = 'USER_IS_LOGGED_OUT',
};